import Loading from '../components/loading'
import Tips from '../components/Tips'
import TipsAuto from '../components/TipsAuto'
import TipsT from '../components/TipsT'
import MidWare from '../components/MidWare'
import Refresh from '../components/refresh'
import NavBar from '../components/NavBar'
import { GlobalStore } from '../store/globalStore'

export default {
	data () {
		return {
			midware: false,
			icon: '',
			midFont: '',
			loading: false,
			tips: false,
			tipsauto: false,
			tipst: false,
			tipsTwoShow: false,
			hasTipsFont: true,
			msg: [],
			btnFont: ['确定', '取消'],
			btnNum: 2,
			tipsFont: 'hahah',
			show: true,
			editStatus: false,
			cls: '',
			font: '',
			editFont: '编辑',
			sec: 1500,
			paperList: [],
			store: GlobalStore
		}
	},
	components: {
		'navbar': NavBar,
		'loading': Loading,
		'tips': Tips,
		'tips-t': TipsT,
		'tips-auto': TipsAuto,
		'mid-ware': MidWare,
		'refresh': Refresh
	},
	created () {
		this.getPaper()
	},
	methods: {
		tipStatus (id) {
			this.delPaperPost(id)
		},
		tipsAuto (msg) {
			var self = this
			self.tipsauto = true
			self.tipsFont = msg
			setTimeout(() => {
				self.tipsauto = false
			}, self.sec)
		},
		delPaper (id) {
			this.tipsFont = '确定要删除这条证照吗？'
			this.btnFont = ['删除', '取消']
			this.tipst = true
			this.$refs.tipst.open(id)
		},
		delPaperPost (id) {
			var delId = {
				id: id
			}
			this.loading = true
			this.$http.post('/cldEdi/sysCert/certificates/delete', delId).then((response) => {
				this.loading = false
				var data = response.body
				if (data.result) {
					var paperList = this.paperList
					for (var k = 0; k < paperList.length; k++) {
						if (id === paperList[k].id) {
							paperList.splice(k, 1)
							break
						}
					}
					this.tipsAuto('删除成功')
					return
				} else {
					this.tipsAuto(data.message)
					return
				}
			}, (response) => {
				this.loading = false
				this.midware = true
				this.icon = 'middle-net'
				this.midFont = '服务中断，稍后请重试！'
			})
		},
		editPaper () {
			// 编辑营业执照
			this.editStatus = !this.editStatus
			if (this.editStatus) {
				this.editFont = '完成'
			} else {
				this.editFont = '编辑'
			}
		},
		getPaper () {
			// 对接获取证照列表接口
			this.loading = true
			this.$http.post('/cldEdi/sysCert/getSysCertListByOrganId').then((response) => {
				this.loading = false
				this.paperList = response.body.data
			}, (response) => {
				this.loading = false
				this.tipsAuto('服务中断，稍后请重试！')
				return
			})
		}
	}
}



// WEBPACK FOOTER //
// ./src/pages/PagerManager.js